var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketingAutomation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    id: "marketing-automation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 234.539,
    x2: 234.539,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M294.059,258.092c2.076-1.294,3.37-3.911,1.858-6.679c-15.925-29.163-33.004-57.677-51.006-85.602 c0.77-4.793-6.416-8.272-9.271-3.276c-16.093,28.163-37.715,53.127-50.838,82.976c-0.569,1.295-0.588,2.553-0.246,3.663 c-10.885,6.412-15.978,18.855-8.54,30.018c3.603,5.406,9.683,10.112,16.421,9.833c4.469-0.186,8.525-2.586,12.537-4.835 c12.641,22.176,24.887,44.595,37.755,66.638c3.249,5.564,11.893,0.534,8.635-5.047c-12.85-22.011-25.08-44.398-37.701-66.542 c24.525-10.347,51.475-14.392,77.456-19.309C292.524,259.663,293.483,258.979,294.059,258.092z M209.439,270.245 c-3.84-7.772-9.256-14.939-15.446-20.894c7.663-17.055,18.046-32.546,28.529-47.983c8.387,19.35,20.362,36.868,28.843,56.171 C237.063,260.703,222.953,264.587,209.439,270.245z M260.412,253.414c-8.521-19.714-20.791-37.514-29.314-57.227 c-0.734-1.698-1.97-2.482-3.297-2.604c3.972-5.886,7.881-11.81,11.603-17.842c15.746,24.635,30.761,49.733,44.899,75.327 c-7.797,1.458-15.628,2.893-23.431,4.468C260.867,254.853,260.726,254.139,260.412,253.414z M186.754,276.383 c-6.85-6.028-4.735-13.618,2.056-18.078c4.716,4.854,9.04,10.572,11.946,16.695c-1.458,0.748-2.909,1.518-4.362,2.312 C192.438,279.473,190.245,279.455,186.754,276.383z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 305.558,
    x2: 305.558,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M314.698,179.061c-7.147,4.091-14.621,7.619-22.357,10.442c-6.007,2.191-3.414,11.858,2.658,9.643 c8.541-3.116,16.855-6.933,24.746-11.45C325.339,184.494,320.304,175.853,314.698,179.061z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 318.843,
    x2: 318.843,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M307.24,226.016c5.498,0.75,14.082,0.268,18.293,4.434c4.587,4.537,11.661-2.532,7.071-7.071 c-5.983-5.917-14.894-5.939-22.707-7.005c-2.698-0.368-5.356,0.606-6.15,3.492C303.099,222.226,304.534,225.647,307.24,226.016z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 276.998,
    x2: 276.998,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M276.283,152.945c-2.246,6.342-5.342,12.325-8.051,18.473c-2.574,5.843,6.04,10.937,8.635,5.047 c3.057-6.939,6.523-13.703,9.059-20.862C288.084,149.509,278.42,146.911,276.283,152.945z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 268.742,
    x2: 268.742,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M148.71,33.459c78.26,2.448,156.568,1.598,234.846,2.97c-0.001,0.056-0.008,0.108-0.008,0.165 c0.001,8.531,0.022,17.062,0.058,25.593c0.027,6.447,10.027,6.45,10,0c-0.036-8.531-0.056-17.062-0.058-25.593 c0-1.038-0.262-1.907-0.697-2.611c1.417-2.936-0.018-7.388-4.303-7.469c-79.94-1.501-159.915-0.555-239.838-3.055 C142.258,23.258,142.277,33.258,148.71,33.459z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 123.203,
    x2: 123.203,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M118.08,157.972c-0.079,46.314-0.078,92.63,0.288,138.943c0.051,6.446,10.051,6.451,10,0 c-0.366-46.313-0.367-92.629-0.288-138.943C128.091,151.522,118.091,151.523,118.08,157.972z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 253.792,
    x2: 253.792,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M382.993,472.473c-0.324,6.064-0.691,12.126-1.081,18.187c-0.392-0.093-0.812-0.148-1.268-0.148 c-85.322-0.024-170.61-3.27-255.931-3.42c0.288-11.447,0.614-22.893,0.965-34.338c0.198-6.452-9.803-6.433-10,0 c-0.402,13.107-0.783,26.215-1.096,39.324c-0.044,1.86,0.758,3.18,1.922,3.966c0.772,0.634,1.795,1.034,3.078,1.034 c87.033,0.024,174.029,3.409,261.062,3.434c0.292,0,0.566-0.026,0.832-0.065c1.084,4.883,9.487,4.353,9.895-1.499 c0.613-8.82,1.15-17.645,1.622-26.474C393.338,466.025,383.336,466.059,382.993,472.473z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 391.013,
    x2: 391.013,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M396.535,286.051c-0.125-21.569-0.465-43.137-1.042-64.699c-0.172-6.436-10.173-6.452-10,0 c0.577,21.563,0.917,43.13,1.042,64.699C386.572,292.497,396.572,292.501,396.535,286.051z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 256.646,
    x2: 256.646,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M296.874,56.912c-14.233,3.919-29.727,3.67-44.371,3.67c-12.489,0-24.963-0.73-37.448-0.77 c-6.45-0.021-6.448,9.979,0,10c12.926,0.041,25.842,0.77,38.772,0.77c15.085,0,31.053,0.007,45.705-4.028 C305.742,64.845,303.102,55.196,296.874,56.912z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 89.43,
    x2: 89.43,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M105.096,432.692c3.231-1.271,6.798-2.287,10.189-3.489c1.677,2.081,3.152,4.349,4.644,6.804 c1.697,2.795,4.762,2.871,6.929,1.549c0.972-0.092,1.958-0.485,2.864-1.274c4.456-3.876,9.062-7.559,13.96-10.862 c0.548-0.37,0.981-0.796,1.32-1.254c0.675-0.222,1.323-0.606,1.909-1.192c1.767-1.768,2.13-5.364,0-7.07 c-2.483-1.989-4.925-4.016-7.034-6.396c2.836-4.637,4.966-9.472,5.925-14.865c0.749-0.133,1.49-0.302,2.217-0.476 c0.812-0.194,1.618-0.415,2.428-0.614c0.383-0.093,0.768-0.175,1.154-0.247c-0.858,0.172,1.107,0.075-0.13-0.096 c1.395,0.192,2.772,0.015,3.894-0.592c2.286-0.216,4.314-1.804,4.099-4.783c-0.429-5.947,1-11.808,1.109-17.744 c0.019-1.032-0.223-1.897-0.641-2.599c-0.269-2.393-2.427-4.714-4.971-4.503c-2.604,0.216-5.143-0.063-7.684-0.227 c-0.646-6.669-3.285-13.079-7.046-18.615c2.11-1.87,4.075-3.907,5.952-6.014c1.312-0.064,2.624-0.594,3.487-1.457 c2.093-2.093,1.689-4.935,0-7.07c-4.799-6.069-11.504-10.234-16.303-16.303c-1.693-2.142-5.313-1.759-7.071,0 c-0.01,0.01-0.018,0.021-0.028,0.03c-0.7,0.242-1.374,0.609-1.974,1.113c-3.633,3.05-6.081,7.09-8.86,10.864 c-2.529-1.323-5.076-2.614-7.762-3.543c-0.247-3.804-0.825-7.621-1.705-11.3c-0.487-2.037-1.835-3.127-3.38-3.461 c-0.459-0.32-1.001-0.582-1.643-0.754c-6.123-1.645-14.454-1.99-20.54,0c-1.057,0.346-1.846,0.924-2.407,1.629 c-2.723,0.86-3.666,3.444-3.3,6.076c0.339,2.447,0.293,4.771,0.062,7.139c-5.471,1.27-10.521,3.836-15.505,6.416 c-3.861-3.334-7.791-6.481-12.695-8.267c-0.68-0.247-1.383-0.287-2.063-0.172c-1.274-0.002-2.526,0.444-3.355,1.458 c-4.684,5.729-10.384,10.601-14.089,17.092c-1.312,2.299-0.634,4.499,0.841,5.912c0.551,0.617,1.299,1.119,2.266,1.428 c2.542,0.812,4.782,2.711,6.717,4.744c-2.327,4.91-3.628,10.235-4.676,15.572c-2.871,0.209-5.728,0.559-8.592,0.918 c-2.451,0.309-4.549,1.728-4.922,4.211c-0.364,0.854-0.507,1.845-0.315,2.95c0.943,5.438,0.067,11.067,0.515,16.554 c0.024,0.293,0.074,0.568,0.136,0.835c-0.102,3.046,2.367,6.282,6.193,5.234c2.691-0.736,5.353-1.147,8.079-1.117 c0.786,3.364,0.764,7.517,1.668,11.273c-2.67,2.176-5.275,4.431-8.042,6.485c-2.187,1.624-3.281,4.291-1.794,6.841 c4.268,7.32,10.559,13.114,16.227,19.317c1.781,1.949,5.29,1.944,7.071,0c3.017-3.292,6.475-6.065,9.924-8.864 c4.257,3.529,9.762,6.179,15.232,6.708c0.002,0.063,0.007,0.127,0.008,0.191c0.042,1.599-0.072,3.201-0.085,4.801 c-0.022,2.762,1.798,4.337,3.892,4.732c0.511,0.174,1.083,0.271,1.72,0.268c6.826-0.036,13.665-0.465,20.459-1.108 c2.734-0.259,4.301-2.255,4.692-4.399c0.185-0.509,0.295-1.077,0.308-1.711C104.617,437.107,104.955,434.909,105.096,432.692z  M44.996,428.18c-3.122-3.352-6.256-6.541-8.902-10.127c2.417-1.999,4.799-4.044,7.313-5.911c0.453-0.336,0.822-0.713,1.124-1.114 c1.385-1.412,1.974-3.543,0.67-5.763c-1.308-2.227-1.462-5.874-1.836-8.565c-0.442-3.184-0.862-6.21-2.168-9.168 c-0.791-1.794-2.869-2.58-4.773-2.417c-0.114-0.019-0.224-0.05-0.34-0.064c-2.454-0.301-4.939-0.239-7.399,0.063 c-0.039-3.172,0.042-6.337-0.136-9.501c2.595-0.281,5.192-0.5,7.813-0.523c0.263-0.002,0.511-0.026,0.752-0.061 c1.883-0.051,3.618-1.145,4.069-3.61c1.185-6.474,2.314-13.319,5.596-19.111c0.653-1.154,0.803-2.281,0.609-3.299 c0.117-1.425-0.384-2.895-1.391-4.079c-2.108-2.482-4.535-4.821-7.265-6.669c2.311-2.898,4.958-5.534,7.444-8.301 c3.271,1.824,6.057,4.672,8.83,7.069c0.799,0.691,1.66,1.072,2.518,1.217c1.08,0.281,2.294,0.196,3.542-0.435 c5.549-2.805,10.954-5.979,17.104-7.259c0.417-0.087,0.792-0.212,1.132-0.366c2.131-0.072,4.446-1.438,4.763-3.644 c0.364-2.53,0.802-5.066,0.942-7.622c0.064-1.166-0.005-2.338-0.124-3.506c3.746-0.796,8.243-0.63,11.956,0.146 c0.565,2.951,0.883,5.946,0.95,8.952c-0.141,1.256,0.165,2.561,0.919,3.595c0.516,1.144,1.547,2.066,3.199,2.417 c4.141,0.879,7.657,3.034,11.391,4.931c0.585,0.297,1.163,0.469,1.723,0.544c1.834,0.758,4.154,0.533,5.48-1.04 c3.063-3.63,5.46-7.874,8.702-11.348c2.888,2.944,6.098,5.566,9.081,8.415c-2.451,2.737-5.089,5.371-8.112,7.379 c-2.266,1.505-3.231,4.388-1.794,6.841c0.604,1.032,1.618,1.809,2.756,2.205c3.632,4.661,5.999,10.63,6.272,16.584 c-1.913,3.178,0.785,8.677,5.637,7.657c2.396-0.503,4.899-0.141,7.396,0.127c-0.268,3.607-0.833,7.196-1,10.803 c-0.736,0.108-1.477,0.245-2.244,0.434c-2.005,0.493-3.367,0.99-5.188,0.778c-2.646-0.309-4.88,2.375-4.989,4.813 c-0.456,0.77-0.751,1.666-0.856,2.622c-0.636,5.795-3.844,10.849-7.081,15.537c-2.025,2.933-0.298,5.762,2.268,6.833 c0.207,0.391,0.441,0.771,0.731,1.126c0.991,1.21,2.086,2.31,3.226,3.362c-3.277,2.359-6.456,4.856-9.552,7.45 c-1.651-2.412-3.455-4.738-5.454-6.794c-0.74-0.762-1.55-1.201-2.366-1.393c-0.818-0.232-1.682-0.233-2.499,0.106 c-5.608,2.332-11.573,3.761-17.106,6.282c-0.233,0.088-0.46,0.182-0.666,0.297c-0.019,0.009-0.038,0.017-0.057,0.025 c-2.422,1.155-2.952,3.323-2.332,5.262c0.014,0.129,0.014,0.256,0.034,0.385c-0.141-0.876-0.032,0.995-0.031,0.932 c-0.01,0.843-0.121,1.686-0.216,2.521c-0.066,0.572-0.135,1.144-0.203,1.714c-3.752,0.295-7.513,0.507-11.274,0.616 c-0.051-2.618-0.411-5.207-1.87-7.419c-1.225-1.856-3.383-2.81-5.468-2.32c-0.06,0.009-0.118,0.012-0.179,0.022 c-4.505,0.799-10.98-3.786-13.912-7.115c-2.071-2.353-4.792-1.889-6.564-0.242c-0.171,0.117-0.341,0.244-0.507,0.387 C51.745,422.697,48.242,425.161,44.996,428.18z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 89.592,
    x2: 89.592,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M101.944,411.981c19.605-8.335,33.32-33.53,21.558-53.228 c-5.553-9.299-16.305-14.715-26.699-16.326c-8.843-1.37-17.281,0.001-24.663,4.046c-1.229-0.515-2.693-0.51-4.2,0.364 c-16.234,9.419-20.188,30.605-13.518,47.206C62.36,413.801,83.037,420.02,101.944,411.981z M66.584,361.135 c1.382,0.261,2.889-0.083,4.2-1.354c6.807-6.603,15.38-8.946,24.746-7.495c8.111,1.257,15.749,5.507,20.01,12.642 c9.088,15.218-6.05,33.561-19.844,38.888c-13.672,5.28-27.389-0.791-32.419-14.479C59.88,380.096,60.649,368.854,66.584,361.135z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 437.893,
    x2: 437.893,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M511.545,136.251c-2.387-22.568-15.917-41.899-35.029-53.714 c-12.583-7.778-27.465-11.439-42.123-10.425c-15.235-3.529-31.121-1.593-43.792,8.164c-12.486,9.614-20.006,24.144-23.803,39.204 c-8.063,31.977,0.173,69.449,29.394,87.719c31.837,19.906,75.701,8.014,99.055-19.441 C507.399,173.474,513.524,154.959,511.545,136.251z M499.325,160.484c-10.543,34.499-52.735,54.248-86.35,43.55 c-31.806-10.123-42.836-44.928-37.908-75.244c2.276-14.005,7.942-27.894,18.315-37.837c7.399-7.093,16.661-10.292,26.29-10.473 c0.846,2.132,2.953,3.771,5.819,3.063c2.663-0.658,5.337-1.106,8.007-1.368c0.032,0.008,0.065,0.015,0.097,0.023 c1.274,0.333,2.395,0.192,3.324-0.249c18.349-0.682,36.239,7.527,48.986,21.015C500.346,118.244,505.446,140.455,499.325,160.484z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 444.168,
    x2: 444.168,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M472.926,144.942c-21.679-8.106-33.374-30.463-51.346-43.827c-4.885-3.632-9.584,3.878-5.823,7.936 c-1.894,0.627-3.437,2.211-3.342,4.59c0.114,2.855,0.815,5.606,1.274,8.387c1.995,19.403-3.812,39.119-1.095,58.619 c0.484,3.476,4.767,4.182,7.345,2.988c17.845-8.263,33.745-20.712,52.987-25.766c3.314-0.871,4.117-4.005,3.204-6.504 C476.743,148.966,475.882,146.047,472.926,144.942z M441.422,134.518c6.2,6.431,12.953,12.105,20.675,16.321 c-14.239,5.291-26.979,13.814-40.46,20.831c-0.809-14.849,2.312-29.667,2.139-44.506c0.218-0.585,0.325-1.26,0.281-2.03 c-0.084-1.464-0.314-2.901-0.578-4.331c-0.167-1.958-0.413-3.917-0.747-5.876C429.371,121.021,435.192,128.056,441.422,134.518z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 364.617,
    x2: 364.617,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M360.592,298.204c-15.34-3.591-31.248-2.349-44.951,5.973c-13.273,8.06-22.12,21.459-27.772,35.614 c-11.58,28.998-9.944,67.09,8.773,92.824c22.244,30.582,64.146,36.688,97.545,22.605c34.477-14.538,59.238-48.884,53.722-87.175 C441.9,326.345,401.769,295.35,360.592,298.204z M438.697,382.102c-1.241,37.258-35.201,64.738-70.009,69.915 c-17.817,2.649-36.121-1.739-50.764-12.147c-13.104-9.314-20.842-23.509-24.595-38.866c-7.051-28.852-0.662-66.037,23.429-85.494 c7.995-6.457,17.692-9.171,27.562-9.212c0.688,2.379,2.901,4.354,6,3.584c3.118-0.775,6.239-1.303,9.347-1.615 c0.104,0.027,0.208,0.048,0.312,0.075c1.372,0.36,2.57,0.176,3.539-0.349C403.457,306.332,440.063,341.09,438.697,382.102z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 368.533,
    x2: 368.533,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M388.881,384.511c-11.782,1.522-23.629,0.392-35.345-1.202c0.125-3.764,0.342-7.53,0.695-11.303 c0.855-9.129,2.324-19.033,6.995-27.077c4.063-6.998,9.909-7.716,17.292-4.805c6.006,2.369,8.585-7.306,2.658-9.643 c-9.097-3.588-18.957-2.508-25.552,5.178c-6.873,8.011-9.173,19.279-10.575,29.439c-2.952,21.404-0.983,42.694-0.92,64.164 c0.019,6.448,10.019,6.449,10,0c-0.035-12.022-0.692-23.985-0.732-35.962c11.771,1.584,23.651,2.739,35.484,1.21 C395.184,393.696,395.264,383.686,388.881,384.511z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 73.811,
    x2: 73.811,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M33.163,144.38c32.015,19.087,75.599,6.973,98.55-20.666 c11.926-14.361,17.757-32.842,15.431-51.432c-2.805-22.413-16.661-41.416-35.943-52.776c-12.332-7.266-26.71-10.645-40.888-9.666 c-15.491-3.563-31.354-1.429-44.192,8.492C13.815,27.844,6.436,42.463,2.759,57.316C-5.174,89.36,3.499,126.693,33.163,144.38z  M11.062,66.618c2.203-14.002,7.829-27.9,18.171-37.854c7.42-7.141,16.727-10.36,26.404-10.542 c0.854,2.115,2.954,3.735,5.806,3.035c2.654-0.651,5.32-1.096,7.983-1.355c0.031,0.008,0.063,0.014,0.095,0.022 c1.267,0.33,2.382,0.19,3.308-0.246c18.278-0.68,36.128,7.424,48.866,20.816c14.371,15.11,19.492,37.101,13.382,56.966 c-10.557,34.328-52.738,53.688-86.119,43.132C17.573,130.667,6.338,96.644,11.062,66.618z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 71.226,
    x2: 71.226,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M36.88,116.771c0.634,2.01,2.567,3.84,4.821,3.671c18.793-1.41,37.17-7.075,56.089-6.545 c0.309,0.035,0.619,0.045,0.927,0.03c0.42,0.017,0.84,0.018,1.261,0.041c5.157,0.279,6.163-6.063,3.077-8.79 c-0.155-18.373,5.242-36.262,6.614-54.544c0.169-2.254-1.661-4.187-3.671-4.821c-20.748-6.55-42.512-1.489-63.711-4.078 c-4.239-0.518-5.63,3.709-4.246,6.841c-2.784-0.387-5.658,1.166-5.226,4.704C35.396,74.404,30.352,96.094,36.88,116.771z  M99.337,54.346c-1.704,16.573-6.181,32.838-6.271,49.53c-16.037,0.367-31.701,4.592-47.651,6.233 c-4.479-18.541-0.298-37.993-2.599-56.83c-0.068-0.561-0.213-1.07-0.413-1.532C61.276,54.025,80.763,49.854,99.337,54.346z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 73.418,
    x2: 73.418,
    y1: 3,
    y2: 515.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0088ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e8de"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M66.328,89.117c7.194,2.866,15.929-1.865,20.371-7.392c5.511-6.858,5.746-15.345,0.142-22.18 c-1.9-2.317-4.433-2.021-6.197-0.547c-0.586-0.667-1.431-1.176-2.575-1.409c-8.365-1.704-16.724,2.607-20.536,10.233 C53.255,76.378,57.772,85.709,66.328,89.117z M66.334,72.488c1.122-3.396,5.651-5.954,9.076-5.256 c1.665,0.339,3.073-0.09,4.132-0.921c0.074,0.102,0.145,0.205,0.227,0.306c4.685,5.714-3.427,13.177-9.13,13.219 C66.723,79.863,65.311,75.584,66.334,72.488z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingAutomation);
export default __webpack_public_path__ + "static/media/marketing-automation.f2e5451cc3041bab0e4c69033cb66ba6.svg";
export { ForwardRef as ReactComponent };